import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import loadable from '@loadable/component';
import Modal from '../../components/modal';

import feedbackActions from './actions';

const FeedbackForm = loadable(() =>
  import(/* webpackChunkName: "extra" */ './components/feedback-form')
);

const Feedback = ({ feedback, close }) => (
  <React.Fragment>
    {feedback.open === true && (
      <Modal width={800} isOpen={feedback.open} onRequestClose={close}>
        <FeedbackForm />
      </Modal>
    )}
  </React.Fragment>
);

Feedback.propTypes = {
  feedback: PropTypes.shape({
    open: PropTypes.bool.isRequired,
  }).isRequired,
  open: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};

export default connect(
  state => ({
    feedback: state.feedback,
  }),
  feedbackActions
)(Feedback);
